import { toast } from "react-toastify";
import useAuth from "../../../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { CustomButton } from "../../../atoms/CustomButton";
import { useUpdateAvatar } from "../../../../hooks/cdn";
import {
  useDeleteUserProfileAvatar,
  useUpdateUserProfileAvatar,
} from "../../../../hooks/users";

const ProfileAvatar = ({
  avatar,
  entity_identification,
  customerId,
}: {
  avatar?: string;
  entity_identification: string;
  customerId: string;
}) => {
  const [t] = useTranslation();
  const { customer_identification } = useAuth();

  const inputFileRef = useRef<any>(null);
  const { mutate, isLoading: isUploading } = useUpdateAvatar();
  const { mutate: updateAvatar, isLoading: isUpdating } =
    useUpdateUserProfileAvatar();
  const { mutate: deleteAvatar, isLoading: isDeleting } =
    useDeleteUserProfileAvatar();

  const handleTriggerFileInput = () => {
    let inputFileElement = document.getElementById("avatarInput");

    inputFileRef.current.value = "";

    inputFileElement?.click();
  };

  const handleUploadAvatar = (files: any) => {
    if (files.length > 0) {
      if (files[0].size > 3 * 1048576)
        return toast.error(t("imageUpload.tooLarge", { max: 3 }) as string);

      mutate(
        {
          user_identification: customer_identification,
          entity_identification: entity_identification,
          data: { image: files[0] } as any,
        },
        {
          onSuccess: (res: any) => {
            updateAvatar(
              {
                customer_identification: customer_identification,
                entity_identification: entity_identification,
                user_identification: customerId,
                data: { avatar: res?.data?.element[0]?.cdnPath } as any,
              },
              {
                onSuccess: () => {
                  inputFileRef.current.value = "";
                },
              }
            );
          },
        }
      );
    }
  };

  const handleDeleteProfile = () => {
    deleteAvatar({
      customer_identification: customer_identification,
      entity_identification: entity_identification,
      user_identification: customerId,
    });
  };

  return (
    <div className="flex-col justify-start items-start gap-2 flex">
      <div className="text-gray-500 text-xs font-normal font-figtree leading-none">
        {t("dashboard.profile.key4")}
      </div>
      <div className="justify-start items-center gap-5 inline-flex">
        <div className="w-12 h-12 relative bg-gray-100 rounded-xl">
          <img
            title="Super User Manager"
            loading="lazy"
            src={avatar ? avatar : "/images/avatar.png"}
            alt="UMD user avatar"
            className="w-full h-full rounded-xl object-cover"
          />
        </div>
        <div className="justify-start items-center gap-3 flex">
          <CustomButton
            onClick={handleTriggerFileInput}
            isLoading={isUpdating || isUploading}
            disabled={isUpdating || isUploading}
            title={t("dashboard.userProfile.profileAvatar.btn-01")}
          />

          {avatar && (
            <CustomButton
              onClick={handleDeleteProfile}
              isLoading={isDeleting}
              disabled={isDeleting}
              title={t("common.delete")}
            />
          )}
        </div>
      </div>

      <input
        type={"file"}
        hidden
        id="avatarInput"
        accept=".jpg,.png,.jpeg"
        onChange={(e) => handleUploadAvatar(e.target.files)}
        ref={inputFileRef}
      />
    </div>
  );
};

export default ProfileAvatar;
